export default "__VITE_ASSET__BkmvtnlT__"